import { watch, onMounted, reactive } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { useCountries, useValidationRules } from '~/composables';


export default {
  __name: 'ServiceFormCourierDeliveryFields',
  props: {
  selectedCountry: {
    type: [String, Number],
    default: null,
  },
},
  emits: ['change', 'countries-loaded'],
  setup(__props, { emit }) {

const props = __props;





const neededCountriesCodes = [
  'AT',
  'BE',
  'HR',
  'CZ',
  'EE',
  'FR',
  'DE',
  'HU',
  'LT',
  'LV',
  'NL',
  'PL',
  'PT',
  'SK',
  'SI',
  'ES',
  'DK',
];
const { getCountriesList } = useCountries();

const localFormData = reactive({
  buildingNumber: '',
  city: '',
  apartmentNumber: '',
  street: '',
  postalCode: '',
});

const { required, errorMessage } = useValidationRules();

const v$ = useVuelidate(
  {
    buildingNumber: { required },
    city: { required },
    apartmentNumber: { required },
    street: { required },
    postalCode: { required },
  },
  localFormData,
);

const handleFieldChange = (fieldName, value) => {
  localFormData[fieldName] = value;
  v$.value[fieldName].$touch();

  emit('change', { fieldName, fieldValue: value });
};

watch(
  () => props.selectedCountry,
  () => {
    Object.assign(localFormData, {
      buildingNumber: '',
      city: '',
      apartmentNumber: '',
      street: '',
      postalCode: '',
    });
    v$.value.$reset();
  },
);

onMounted(() => {
  const countries = getCountriesList().filter((country) =>
    neededCountriesCodes.includes(country.code),
  );

  emit('countries-loaded', countries);
});

return { __sfc: true,props, emit, neededCountriesCodes, getCountriesList, localFormData, required, errorMessage, v$, handleFieldChange }
}

}